import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { LoginSession } from '../../types'
import type { RootState } from '../index'

interface SessionsState {
  sessions: LoginSession[]
}

const initialState: SessionsState = {
  sessions: [],
}

const sessionsSlice = createSlice({
  name: 'sessions',
  initialState,
  reducers: {
    setSessions(state, action: PayloadAction<LoginSession[]>) {
      state.sessions = action.payload
    },
    removeSession(state, action: PayloadAction<string>) {
      state.sessions = state.sessions.filter(s => s.id !== action.payload)
    },
    removeAllExceptCurrent(state) {
      state.sessions = state.sessions.filter(s => s.current)
    },
    clearSessions(state) {
      state.sessions = []
    },
  },
})

export const selectSessions = (state: RootState) => state.sessions.sessions

export const { setSessions, removeSession, removeAllExceptCurrent, clearSessions } = sessionsSlice.actions
export default sessionsSlice.reducer
